import React from 'react';
import { Box, Card, CardActionArea, Typography } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';

interface SectionTypeCardProps {
    icon: React.ReactNode;
    label: string;
    description: string;
    selected: boolean;
    onSelect: () => void;
}

// Cartão de escolha do tipo de seção nos drawers de criação
export function SectionTypeCard({ icon, label, description, selected, onSelect }: SectionTypeCardProps) {
    return (
        <Card
            variant="outlined"
            sx={{
                height: '100%',
                borderColor: selected ? 'primary.main' : 'divider',
                borderWidth: selected ? 2 : 1,
                bgcolor: selected ? 'action.selected' : 'background.paper',
                transition: 'all 0.15s ease-in-out',
            }}
        >
            <CardActionArea onClick={onSelect} sx={{ height: '100%', p: 1.5, display: 'flex', alignItems: 'flex-start', justifyContent: 'flex-start', gap: 1.5 }}>
                <Box sx={{ color: selected ? 'primary.main' : 'text.secondary', mt: 0.25 }}>{icon}</Box>
                <Box sx={{ flex: 1, minWidth: 0 }}>
                    <Typography variant="body2" fontWeight={600}>{label}</Typography>
                    <Typography variant="caption" color="text.secondary" component="div">{description}</Typography>
                </Box>
                {selected && <CheckCircleIcon color="primary" fontSize="small" />}
            </CardActionArea>
        </Card>
    );
}
